import { breakpoints, Button } from "@brightagency/headstart-common";
import React, { FC, useState } from "react";
import styled from "styled-components";
import { useGlobalData } from "../../../../../services/app-state";
import { colors } from "../../../../../utils/colors";
import { GravityForm } from "../../../GravityForm";

const Outer = styled.div`
    padding: 32px 0 0;
    text-align: center;
    margin: 0 auto;
    border: 0 !important;
    outline: 0 !important;
    overflow: hidden;

    ${breakpoints.large} {
        background-color: transparent;
    }
`;

const Text = styled.div`
    font-size: 16px;
    margin-bottom: 16px;
    font-weight: 400;
    color: ${colors.brandDark};
`;

const ButtonWrapper = styled.div`
    width: 100%;
    max-width: 320px;
    margin: 0 auto;
`;

export const Feedback: FC<{ regionName: string }> = props => {
    const [isOpen, setIsOpen] = useState(false);
    const [{ acf }] = useGlobalData();

    return (
        <Outer>
            <Text>Is this listing not up to date?</Text>

            {!isOpen && (
                <ButtonWrapper>
                    <Button
                        onClick={(e: MouseEvent) => {
                            e.preventDefault();
                            e.stopPropagation();
                            setIsOpen(true);
                        }}
                        appearance="subtle"
                        maxWidth={-1}
                    >
                        Let us know
                    </Button>
                </ButtonWrapper>
            )}

            {isOpen && (
                <GravityForm
                    formId={acf?.form_mappings.listing_feedback ?? "1"}
                    variableReplacements={{ "{regionName}": props.regionName }}
                    submitButtonAlignment="center"
                    autoFocusFirstField
                />
            )}
        </Outer>
    );
};
